import { getAxiosBackendApi3 } from "../helpers/axios"

class NameTeamServices{

    constructor(){
    }

    addNameTeam(data){
        return getAxiosBackendApi3().post('presidents', data)
    }
}

export default new NameTeamServices()